import {TheRave} from "../TheRave";
import {Layers, TheRaveLayers} from "./TheRaveLayers";
import {TweenLite} from "gsap";
import {FontStyleConfig} from "../config/FontConfig";
import {BitmapCountUp} from "../coutup/BitmapCountUp";
import {TheRaveReelView} from "../reels/TheRaveReelView";
import {TheRaveSymbol} from "../symbol/TheRaveSymbol";
import {MathHelper} from "../../core/utils/MathHelper";
import {Helper} from "../../core/utils/Helper";
import {TimelineLite} from "gsap";
import {TheRaveSound} from "../sound/TheRaveSound";
export class FSPlus extends PIXI.Container {


    constructor() {
        super();
    }

    public play(sym:TheRaveSymbol, addFS:number): void {
        if(sym.symbolName === "S") {
            const plus:PIXI.Sprite = new PIXI.Sprite(TheRave.assetLoader.getTextures(`plus${addFS === 2?"Two":"One"}`)[0]),
                plusTl:TimelineLite = new TimelineLite();
            const animationScale:number = MathHelper.roundToDecimals(sym.symbolHeight / 150, 2);
            plus.alpha = 0;
            plus.visible = false;
            plus.anchor.set(0.5, 1);
            plus.scale.set(animationScale, animationScale);
            TheRaveLayers.getLayer(Layers.FOREGROUND_TOP)?.addChild(plus);
            plus.position = Helper.copyLocalPosition(plus, sym);
            const toPos:number = plus.position.y - 100;
            plusTl.add([
                () => {
                    plus.visible = true;
                    TheRaveSound.playSoundEffect(`fsPlusSpins`);
                },
                TweenLite.to(plus, 2, {y : toPos}),
                TweenLite.fromTo(plus, 1, {alpha : 1}, {alpha : 0, delay:1})
            ], 0);
            plusTl.add(() => plus.destroy());
        }
    }
}